import {
  Table,
} from '@mantine/core';
import {
  createFileRoute,
  useParentMatches,
} from '@tanstack/react-router';

import styles from '#features/scout/DigitalAssistants/Ica.module.scss';
import {
  type ReportWithId,
} from '#features/scout/Schema/Reports.schema';
import NoReportFound from '#src/components/errors/NoReportFound';

interface TableRows {
  processeddate: string;
  effectivedate: string;
  description: string;
  debit: string;
  credit: string;
  runningBalance: string;
}

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/reports/$reportId/$abn/ica',
)({
  beforeLoad: () => {
    return {
      crumb: 'ICA',
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const {
    abn,
  } = Route.useParams();
  const parentMatches = useParentMatches();
  const reportData: ReportWithId = parentMatches.at(-1)?.loaderData;
  const {
    clients,
    integratedClientAccount,
  } = reportData;
  if (!clients) {
    throw new Error('Clients unknown');
  }
  const tables: TableRows[] = integratedClientAccount?.find(ica => ica.abn === abn)?.tables?.map(table => table.rows)?.flat(1) ?? [];
  if (tables.length === 0) {
    return (
      <NoReportFound />
    );
  }
  const body = tables?.map((item, rowIndex) => {
    return {
      id: rowIndex,
      columns: [
        item.processeddate,
        item.effectivedate,
        item.description,
        item.debit,
        item.credit,
        item.runningBalance,
      ],
    };
  }) ?? [];
  const tableData = {
    // caption: 'Client reports requested',
    head: [
      'Processed Date',
      'Effective Date',
      'Description',
      'Debit (DR)',
      'Credit (CR)',
      'Running Balance',
    ],
    body,
  };

  const tableRows = tableData.body.map((row, rowIndex) => (
    <Table.Tr
      key={ rowIndex }
      className={ styles.tableRow }
    >
      { row.columns.map((cell, cellIndex) => (
        <Table.Td
          key={ cellIndex }
        >
          { cell }
        </Table.Td>
      )) }
    </Table.Tr>
  ));
  const tableHeader = (rowKey: string) => (
    <Table.Tr
      key={ rowKey }
    >
      { tableData.head.map((col, colIndex) => (
        <Table.Td
          key={ colIndex }
        >
          { col }
        </Table.Td>
      )) }
    </Table.Tr>
  );
  return (
    <Table.ScrollContainer
      className={ styles.tableContainer }
      type="native"
      minWidth={ 500 }
    >
      <Table
        classNames={ {} }
        // data={tableData}
        verticalSpacing="sm"
        horizontalSpacing="lg"
        striped="odd"
        stripedColor="oklch(1 0 0 /0.05)"
        highlightOnHoverColor="primary.9"
        highlightOnHover
        stickyHeader
        withColumnBorders
        tabularNums
      >
        <Table.Thead>{ tableHeader('ica-table-header') }</Table.Thead>
        <Table.Tbody>{ tableRows }</Table.Tbody>
        { /* <Table.Tfoot>{tableHeader("requests-table-footer")}</Table.Tfoot> */ }
      </Table>
    </Table.ScrollContainer>
  );
}
